define.alias("shared/components/shared/plan-recommendation/option-card", "settings/components/shared/plan-recommendation/option-card");